<template>
  <div class="operation f fw-w">
    <div style="width: 336px">
      <PlatformCascader @change="platformCascaderChange" ref="PlatformCascader"></PlatformCascader>
    </div>

    <el-select v-model="parameter.storeGroups" style="width: 120px; margin-left: 15px" size="medium" clearable collapse-tags multiple placeholder="分组" @change="change">
      <el-option label="默认" :value="-1" />
      <el-option label="独立站" :value="100" />
    </el-select>

    <el-select v-model="parameter.userIds" size="medium" collapse-tags multiple filterable remote reserve-keyword placeholder="邮箱/手机号" class="default-maggin-left" style="width: 200px;margin-left: 15px" @change="change" :remote-method="userRemoteMethod" :loading="getUserLoading" @blur="userRemoteMethod" clearable>
      <el-option v-for="item in userOptions" :key="item.userId" :label="`${item.email||''}${(item.email&&item.phone?' / ':'')}${item.phone||''}`" :value="item.userId" :title="`${item.email||''}${item.phone?' / '+item.phone:''}`" />
    </el-select>
    <el-select v-model="orderTimeType" size="medium" style="width: 140px;margin-left:15px" class="default-maggin-left rightBorderNone" @change="change">
      <el-option :value="0" label="下单时间"></el-option>
      <!-- <el-option :value="1" label="平台付款时间"></el-option> -->
      <el-option :value="2" label="kaka付款时间"></el-option>
    </el-select>
    <el-date-picker v-model="datePicker" type="datetimerange" size="medium" style="width:380px;margin-right:15px" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" @change="change" />

    <div style="height: 36px">
      <el-popover placement="bottom" trigger="click" width="400">
        <el-input v-model="searchArray" size="medium" clearable class="search-input" placeholder="支持批量搜索(英文逗号隔开)" @change="change" slot="reference">
          <!-- TODO 新增下拉筛选框 -->
          <el-select v-model="searchType" slot="prepend" size="medium" class="search-select" placeholder="请选择" @change="change" style="height: 36px">
            <el-option label="SPU" :value="3" />
            <el-option label="SKU" :value="1" />
            <el-option label="Order Id" :value="0" />
            <el-option label="Store Order ID" :value="2" />
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="change" style="height: 36px" />
        </el-input>
        <el-input v-model="searchArray" type="textarea" resize="none" :rows="6" placeholder="支持批量搜索(英文逗号隔开)" @blur="change" />
      </el-popover>
    </div>

    <el-button @click="$emit('export')" style="height: 36px; margin-left: 10px">数据导出</el-button>
  </div>
</template>

<script>
import PlatformCascader from '@/components/PlatformCascader.vue'
import moment from 'moment'
import API from '@/api'
import { dateFormat } from '@/utils/date'
export default {
  props: {
    shopOptions: {
      type: Array,
      default: () => []
    }
  },
  components: { PlatformCascader },
  data() {
    return {
      parameter: {
        userIds: [],
        orderTimeType: 0,
        platformCode: undefined
      },
      datePicker: [], // 日期
      selectLoading: false,
      searchArray: undefined,
      searchType: 0,
      getUserLoading: false,
      userOptions: [],
      orderTimeType: 0
    }
  },
  methods: {
    platformCascaderChange(data) {
      const { platformCode, storeId } = data
      this.parameter.platformCode = platformCode
      this.parameter.storeIds = storeId
      this.change()
    },
    change() {
      this.$emit('change')
      const params = Object.assign({}, this.parameter, { datePicker: this.datePicker, searchArray: this.searchArray, searchType: this.searchType, orderTimeType: this.orderTimeType })
      this.$store.commit('setState', { key: 'orderGetListParams', value: params })
    },
    getParams() {
      const parameter = { ...this.parameter, searchType: this.searchType, orderTimeType: this.orderTimeType }
      if (this.datePicker && this.datePicker.length) {
        parameter.orderTimeAt = moment(this.datePicker[0]).valueOf()
        parameter.orderTimeTo = moment(this.datePicker[1]).valueOf()
      }
      if (this.searchArray) {
        parameter.searchArray = Array.isArray(this.searchArray) ? this.searchArray : this.searchArray.replace(/[；,，;\s\r\n]+/g, ',').split(',')
      }
      return parameter
    },
    async userRemoteMethod(query) {
      const params = {
        email: query ? query.trim() : '', // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: [],
        // userIds: this.parameter.userIds || []
      }
      this.getUserLoading = true
      let result = await API.getUserOptions(params)
      this.userOptions = result.data.list
      this.getUserLoading = false
    },
    getUserOptions() {
      if (!this.userOptions.length) this.userRemoteMethod()
    },
    getDefaultValue(orderGetListParams) {
      let { datePicker = [], searchArray = undefined, platformCode = undefined, storeIds = [], searchType = 0, orderTimeType = 0, ...parameter } = orderGetListParams
      if (!datePicker.length) {
        datePicker = [new Date(dateFormat(Date.now(), 'yyyy-MM-dd')+' 00:00:00').getTime() - 29 * 24 * 3600000, new Date(dateFormat(Date.now(), 'yyyy-MM-dd')+' 23:59:59').getTime()]
      }
      this.parameter = parameter
      this.datePicker = datePicker
      this.searchArray = searchArray
      this.searchType = searchType
      this.orderTimeType = orderTimeType
      this.$nextTick(() => {
        this.parameter.platformCode = platformCode
        this.parameter.storeIds = storeIds
        this.$refs.PlatformCascader.setDefaulValue({ platform: platformCode, store: storeIds })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.operation {
  // height: 36px;
}

.search-input {
  width: 428px;
  .search-select {
    width: 145px;
  }
}
</style>
